module.exports = __webpack_public_path__ + "static/media/loseZoleTwoNines_1.e6826da3.png";